import { Action } from '@ngrx/store';
import { YourPension } from '../../model/ngrx/your-pension.model';
import * as ProductChoiceActions from './../actions/product-choice.actions';

export type Actions = ProductChoiceActions.Actions;

export function ProductChoiceReducer(state: YourPension[] = [], action: ProductChoiceActions.Actions) {
    switch (action.type) {
        case ProductChoiceActions.ADD_PRODUCT_CHOICE:
            return [...state, action.payload];
        case ProductChoiceActions.REMOVE_PRODUCT_CHOICE:
            state = [];
            return state;

        default:
            return state;
    }
}
